var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlurCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.937,
    height: 38.937,
    viewBox: "0 0 38.937 38.937",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "blur-circular",
    transform: "translate(-1.125 -1.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M20.593,1.125a19.469,19.469,0,1,0,13.766,5.7,19.468,19.468,0,0,0-13.766-5.7Zm11.93,31.4a16.873,16.873,0,1,1,0-23.862A16.893,16.893,0,0,1,32.524,32.524Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M14.387,18.044a3.759,3.759,0,1,0-2.659-1.1,3.759,3.759,0,0,0,2.659,1.1Zm-.824-4.581a1.161,1.161,0,1,1-.342.823,1.164,1.164,0,0,1,.342-.823Z",
    transform: "translate(1.46 1.445)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M22.615,18.044a3.759,3.759,0,1,0-3.474-2.32A3.76,3.76,0,0,0,22.615,18.044Zm-.824-4.581a1.164,1.164,0,1,1,0,1.646A1.164,1.164,0,0,1,21.791,13.462Z",
    transform: "translate(2.725 1.445)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M11.728,20.059a3.736,3.736,0,1,0,2.659-1.111,3.76,3.76,0,0,0-2.659,1.111Zm3.482,3.482a1.164,1.164,0,1,1,0-1.646A1.164,1.164,0,0,1,15.21,23.541Z",
    transform: "translate(1.46 2.739)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M19.957,20.057a3.76,3.76,0,1,0,5.317,0,3.76,3.76,0,0,0-5.317,0Zm3.482,3.482a1.164,1.164,0,1,1,.34-.824,1.164,1.164,0,0,1-.34.824Z",
    transform: "translate(2.725 2.741)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M24.838,7.246a2.4,2.4,0,1,1-2.4-2.4,2.4,2.4,0,0,1,2.4,2.4Z",
    transform: "translate(2.906 0.571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M16.609,7.246a2.4,2.4,0,1,1-2.4-2.4,2.4,2.4,0,0,1,2.4,2.4Z",
    transform: "translate(1.641 0.571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M24.838,29.394a2.4,2.4,0,1,1-2.4-2.4,2.4,2.4,0,0,1,2.4,2.4Z",
    transform: "translate(2.906 3.975)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M16.609,29.394a2.4,2.4,0,1,1-2.4-2.4,2.4,2.4,0,0,1,2.4,2.4Z",
    transform: "translate(1.641 3.975)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M31.8,22.434a2.4,2.4,0,1,1-2.4-2.4A2.4,2.4,0,0,1,31.8,22.434Z",
    transform: "translate(3.975 2.906)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    d: "M31.8,14.206a2.4,2.4,0,1,1-2.4-2.4,2.4,2.4,0,0,1,2.4,2.4Z",
    transform: "translate(3.975 1.641)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M9.651,22.434a2.4,2.4,0,1,1-2.4-2.4A2.4,2.4,0,0,1,9.651,22.434Z",
    transform: "translate(0.571 2.906)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M9.651,14.206a2.4,2.4,0,1,1-2.4-2.4,2.4,2.4,0,0,1,2.4,2.4Z",
    transform: "translate(0.571 1.641)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlurCircular);
export default __webpack_public_path__ + "static/media/blur-circular.caba3d4abdd8e20afadcb4923f846cbd.svg";
export { ForwardRef as ReactComponent };